import React, { useState, useEffect, useRef } from 'react'
import { Button } from 'react-bootstrap';
import useAuth from 'hooks/useAuth'
import { useIdleTimer } from "react-idle-timer/dist/index.legacy.esm";
import httpClient from 'utility/httpClient.util';


const DEFAULT_IDLE = 30 //min
const DEFAULT_PROMPT = 120
const IdleScreen = () => {


    const [idleTime, setIdleTime] = useState(DEFAULT_IDLE);
    const [promptTime,setPromptTime] = useState(DEFAULT_PROMPT)
    const {user,config,isLoggedIn,logout,logoutLocal} = useAuth();
    const [showModal, setShowModal] = useState(false);
    const [forceLogout, setForceLogout] = useState(false);
    const [remainingTime, setRemainingTime] = useState(0);
    const [isIdle,setIsIdle] = useState(false)
  
    const handleIdle = () => {
      if(isLoggedIn){
        setShowModal(true); //show modal      
        setIsIdle(true)
        setRemainingTime(promptTime); //set 15 seconds as time remaining
      }
    };

    const handleOnIdle = ()=>{
       
    }

    const handleOnActive = ()=>{
      setIsIdle(false)
      console.log("onActive");
    }

    const handleOnMessage = async (obj) =>{
      console.log("onMessage",new Date(),obj)
      if(obj==='onUserClickActive'){
        onActiveWorking()     
      }
    }
  
    //const { isIdle,    getRemainingTime,getLastActiveTime } = useIdle({ onIdle: handleIdle, idleTime: 0.3});
    const {  getRemainingTime, getLastActiveTime,message,start } = useIdleTimer({
        timeout: 1000 * 60 * idleTime  ,
        onIdle: handleIdle,
        onActive : handleOnActive,
        onMessage: handleOnMessage,
        debounce: 500,
        crossTab: true,
        syncTimers: 200
      });

    useEffect(() => {
      let interval;
  
      if (showModal) {
        interval = setInterval(() => {
          setRemainingTime(
            (prevRemainingTime) =>
              prevRemainingTime > 0 ? prevRemainingTime - 1 : 0 //reduces the second by 1
          );
        }, 1000);
      }
  
      return () => {
        clearInterval(interval);
      };
    }, [isIdle, showModal]);
  
    useEffect(() => {
      if (remainingTime === 0 && showModal && isIdle) {
        // alert("Time out!");
        //setShowModal(false);
        //navigate("/");
       //localStorage.setItem('force-logout','true')
        setForceLogout(true)
      }
    }, [remainingTime, showModal]); // this is responsoble for logging user out after timer is down to zero and they have not clicked anything

    useEffect(() => {
      const channel = new BroadcastChannel('user-profile-bc');
      channel.onmessage = async (event) => {
        console.log("user-profile-bc",event.data)
        if (event?.data?.type === 'logout') {
          if(user?.tabId !== event?.data?.tabId){
            await logoutLocal();
            setShowModal(false);
            setForceLogout(false);
            setIsIdle(false);
          }
        }
      };
      return () => channel.close();
    }, []);
  
    useEffect(()=>{
        if(config){
            let find = config.find(({configCode})=>configCode==='user_idle_time') || {jsonData:{idleTimeMin: DEFAULT_IDLE,promptTimeoutSec: DEFAULT_PROMPT}}
            if(find ){
                const {idleTimeMin,promptTimeoutSec}  = Object.assign({idleTimeMin: DEFAULT_IDLE,promptTimeoutSec: DEFAULT_PROMPT},find.jsonData)
                setIdleTime(idleTimeMin)
                setPromptTime(promptTimeoutSec)
            }
        }
    },[config])

    useEffect(()=>{
        const forceLogout = localStorage.getItem('force-logout') || 'false'
        if(forceLogout==='true' && isLoggedIn){
            //Check
            try{
              httpClient.get("/kc/userinfo")              
              localStorage.removeItem('force-logout')
            } catch (err) {
              setShowModal(true)
              setForceLogout(true)
              console.error(err)
            }
        }else{
            localStorage.removeItem('force-logout')
        }
    },[isLoggedIn])
  
    const handleStayLoggedIn = () => {
      setShowModal(false);
  
    };
  
    const millisToMinutesAndSeconds = (millis)=> {
      var minutes = Math.floor(millis / 60000);
      var seconds = ((millis % 60000) / 1000).toFixed(0);
      return minutes + ":" + (seconds < 10 ? "0" : "") + seconds;
    }

    const onActiveWorking = ()=>{
        httpClient.get("/hr/profile/me")
        setShowModal(false)
        start()
    }

    const handleLogOut = async ()=>{
        try {
            //handleClose();
            localStorage.removeItem('force-logout')
            httpClient.get("/hr/profile/me")
            await logout()
          } catch (err) {
            console.error(err)
          }
    }

    return (
        <>     
		{/* your app here */}   
        {showModal === true&& (<div className="splash-screen">
            <div className='login-pf-page'>
                <div id="kc-header" class="login-pf-page-header">

                    <div class="logo">
                        <img alt="CkDoctor" src={`${process.env.PUBLIC_URL}/logo/logo-white-256.png`} width="256" />                        
                    </div>
                </div>
                <div class="card-pf">
                    <header class="login-pf-header text-center">
                        <h1 id="kc-page-title">    </h1>
                        <h1 id="kc-page-title">    Still with us?{isIdle?'':'...^-^//'}</h1>
                        {remainingTime > 0 && !forceLogout  &&(<h5 className='m-l-20 m-r-20'>We will log you out in <span className='text-danger'>{remainingTime} seconds</span> unless you confirm you're still with us</h5>)}
                        {(remainingTime == 0 || forceLogout)  &&(<h5 className='m-l-20 m-r-20'>Hey there!  It looks like your previous session timed out, or an admin might have ended it.</h5>)}                     
                        <br/>                    
                        {remainingTime > 0 && !forceLogout  &&(<Button variant="success" onClick={()=>{onActiveWorking();message('onUserClickActive', true);}}>Continue Working</Button>)}
                        <br/>
                        <Button className='m-t-10' variant="outline-info" onClick={handleLogOut}>Logout now</Button>
                    </header>
    

                </div>
            </div>

            {/* Add any other loading indicators or branding */}
        </div>)}
        </>
    );
};

export default IdleScreen;